const Notifications = () => {
  return <></>;
};

export default Notifications;
